module.exports = __webpack_public_path__ + "assets/img/member_icon.1e5cabaf.svg";